import { Mote } from './mote';
import { Media } from './media';
import { ElementRef } from '@angular/core';

export enum MediaState {
    NONE = "NONE",
    PLAYING = "PLAYING",
    PAUSED = "PAUSED",
    LOADED = "LOADED",
    VERSION_ERROR = "VERSION_ERROR"
}

export enum MediaEventType {
    INITIAL = "INITIAL",
    PROGRESSUPDATE = "PROGRESSUPDATE",
    LOAD_PROGRESS = "LOAD_PROGRESS",
    STATEUPDATE = "STATEUPDATE",
    SEEK = "SEEK",
    SET_CURRENT_TIME = "SET_CURRENT_TIME",
    SHOW_IMAGE = "SHOW_IMAGE",
    PRELOAD_MEDIA = "PRELOAD_MEDIA",
    PLAY_ERROR = "PLAY_ERROR",
    VERSION_ERROR = "VERSION_ERROR"
}

export class MediaEvent {
    public type: MediaEventType;
    public mote: Mote = null;
    public media: Media = null;
    public state: MediaState = MediaState.NONE;
    public progress: number = 0;
    public loadPct: number = 0;
    public seekSec: number = 0;
    public duration: number = 0;
    public player: ElementRef;
    public bufferPct = 0;

    constructor(moteToPlay: Mote, media: Media, type: MediaEventType, state: MediaState, player: ElementRef = null, progress: number = null, bufferPct: number = null, loadPct: number = null) {
        this.update(moteToPlay, media, type, state, player, progress, bufferPct, loadPct);
    }

    public update(
        mote: Mote,
        media: Media,
        type: MediaEventType,
        state: MediaState,
        player: ElementRef = null,
        progress: number = null,
        duration: number = null,
        bufferPct: number = null,
        loadPct: number = null
    ): void {
        this.state = state;
        this.mote = mote;
        this.media = media;
        this.type = type;
        this.player = player;
        this.duration = duration;
        if(progress != null) this.progress = progress;
        if(bufferPct != null) this.bufferPct = bufferPct;
        if(loadPct != null) this.loadPct = loadPct;
    }

    public updateProgress(progress: number): void {
        this.update(this.mote, this.media, MediaEventType.PROGRESSUPDATE, MediaState.PLAYING, this.player);
    }
}

export enum MotesMediaPlayerPosition {
    BOTTOM = 'bottom',
    TOP = 'top',
    STATIC = 'static'
}

export interface MotesMediaPlayerConfig {
    position: MotesMediaPlayerPosition
}

export interface AudioProgressEv {
    // Partly implemented interface of HTMLMediaElement progress event
    // We only use the these few options from the AudioElement of the progress event
    srcElement: { buffered: TimeRanges, currentTime: number, duration: number }  // -> HTMLMediaElement -> HTMLAudioElement;
}
